var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 896,
    viewBox: "0 0 672 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#account_setup_svg__clip0_3670_68808)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M0 0h224v224H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 0H0v224c123.694 0 224-100.269 224-224z",
    fill: "#105ED5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M224 0h224v224H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 224V0H224c0 123.694 100.269 224 224 224zM448 0h224v224H448z",
    fill: "#FD8F52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M0 224h224v224H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 224v224h224c0-123.694-100.269-224-224-224z",
    fill: "#105ED5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M224 224h224v224H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 448h224V224c-123.694 0-224 100.269-224 224z",
    fill: "#026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M448 224h224v224H448z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 448h224V224c-123.694 0-224 100.269-224 224z",
    fill: "#026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M0 448h224v224H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 448v224h224c0-123.694-100.269-224-224-224z",
    fill: "#FD8F52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M224 448h224v224H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 448H224v224c123.694 0 224-100.269 224-224z",
    fill: "#026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M448 448h224v224H448z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672 448H448v224c123.694 0 224-100.269 224-224z",
    fill: "#026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M0 672h224v224H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 672v224h224c0-123.694-100.269-224-224-224z",
    fill: "#026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M224 672h224v224H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 896h224V672c-123.694 0-224 100.269-224 224z",
    fill: "#105ED5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M448 672h224v224H448z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 896h224V672c-123.694 0-224 100.269-224 224z",
    fill: "#105ED5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "account_setup_svg__clip0_3670_68808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 672,
    height: 896,
    rx: 32,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSetup);
export default __webpack_public_path__ + "static/media/account_setup.d6631315852b650fc467691c3af4e34f.svg";
export { ForwardRef as ReactComponent };